
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class GravityWavesEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const rings = Math.floor(10 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < rings; i++) {
                const life = (curTime * 0.2 + i / rings) % 1;
                const r = life * Math.max(width, height) * 2 * scale;
                const alpha = (1 - life) * 0.4;
                
                ctx.save();
                ctx.globalAlpha = alpha / (layerIndex + 1);
                ctx.lineWidth = 2 * scale;
                ctx.beginPath();
                ctx.ellipse(0, 0, r, r * 0.5, Math.PI / 4, 0, Math.PI * 2);
                ctx.stroke();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
